var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttentionBid = function SvgAttentionBid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E5F9F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m16.563 13.188.073-.132a3.848 3.848 0 0 1 2.61-1.905v0c.498-.1 1.01-.1 1.509 0v0a3.848 3.848 0 0 1 2.61 1.905L29.55 24.19c.295.531.45 1.129.45 1.736v0c0 1.974-1.6 3.574-3.574 3.574H13.574A3.574 3.574 0 0 1 10 25.926v0c0-.607.155-1.205.45-1.736l3.3-5.94.938-1.688"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20 17v4M20 24v.5"
  })));
};
export default SvgAttentionBid;